import React, { useState, useEffect } from 'react';
import { Link } from "react-router-dom";
import "react-datepicker/dist/react-datepicker.css";
import 'datatables.net';
import 'datatables.net-dt/css/dataTables.dataTables.css';
import $ from 'jquery';
import { Row, Col, Tab, Nav, Badge, Tooltip, OverlayTrigger, Toast } from "react-bootstrap";
import LightGallery from 'lightgallery/react';
// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';
import vendor_1 from '../../../../images/staff/admin.png';
import documents from '../../../../images/doc.png';
import { Button } from "react-bootstrap";
import rice_img from '../../../../images/raw_material/rice.png';
import dhal_img from '../../../../images/raw_material/dhal.png';
import fenugreek_img from '../../../../images/raw_material/fenugreek.png';
import salt_img from '../../../../images/raw_material/salt.png';
import red_chilly_img from '../../../../images/raw_material/red_chilly.png';
import black_sesame_img from '../../../../images/raw_material/black_sesame.png';
import cumin_seeds_powder_img from '../../../../images/raw_material/cumin_seeds_powder.png';
import chana_dal_img from '../../../../images/raw_material/chana_dal.png';
import hing_img from '../../../../images/raw_material/hing.png';
import oil_img from '../../../../images/raw_material/oil.png';
import axios from 'axios';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from 'moment';


const ViewCustomer = () => { 

    const onInit = () => {
        //   console.log('lightGallery has been initialized');
    };
    const [key, setKey] = useState('basic_info');
    const [hovered, setHovered] = useState(false);
    const BaseUrl = process.env.REACT_APP_API_BASE_URL;
    const [paymentModeMap, setPaymentModeMap] = useState({});
    const [totalEntries, setTotalEntries] = useState(0); 
    const [customer, setCustomer] = useState(null);
    const [payments, setPayments] = useState(null);
    const [orders, setOrders] = useState(null);
    const [cateringType, setCateringType] = useState([]);
    const [functionType, setFunctionType] = useState([]);
    const [mealsPeriod, setMealsPeriod] = useState([]);

    const containerStyle = {
        position: 'relative',
        width: '100px',
        height: '110px',
    };

    const imageStyle = {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        transition: 'transform 0.3s ease, box-shadow 0.3s ease',
        transform: hovered ? 'scale(1.05)' : 'scale(1)',
        boxShadow: hovered ? '0 6px 16px rgba(0, 0, 0, 0.25)' : 'none',

    };

    const iconStyle = {
        display: hovered ? 'inline-block' : 'none',
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)', 
        backgroundColor: 'rgb(180, 228, 126)',
        borderRadius: '50%',
        padding: '8px',
        transition: 'opacity 0.3s ease',
    };

     const getStatusLabel = (status) => {
        switch (status) {
        case 0:
            return { label: "Payment Pending", bgColor: "#a70045ff", textColor: "white" };
        case 1:
            return { label: "Paid", bgColor: "#2c6100ff", textColor: "white" };
        case 2:
            return { label: "Verification Pending", bgColor: "#fffb00ff", textColor: "black" };
        case 3:
            return { label: "Cancelled", bgColor: "#ff2121ff", textColor: "white" };
        default:
            return { label: "Unknown", bgColor: "#888", textColor: "white" };
        }
    };


    useEffect(() => {
        const customerId = localStorage.getItem('selectedCustomerId');

        
        const fetchPaymentlist = async () => {
            try {
            const response = await axios.get(`${BaseUrl}/manage_corporate_order/payment_list_by_customer/${customerId}`);
            if (response.data && response.data.success) {
                    setPayments(response.data.data);  // <-- set payments to the array here
                } else {
                console.error('No customer data found for this ID');
                    setPayments([]);
                }
            } catch (error) {
                console.error('Error fetching customer data:', error);
                setPayments(null);
            }
        };
        
        
        const fetchCustomer = async () => {
            try {
                const response = await axios.get(`${BaseUrl}/manage_corporate_customer/get/${customerId}`);
                if (response.data) {
                    setCustomer(response.data);
                } else {
                    toast.error('No Payment data found for this ID');
                    setCustomer(null);
                }
            } catch (error) {
                toast.error('Error fetching customer data:', error);
                setCustomer(null);
            }
        };

        const fetchOrder = async () => {
            try {
                const response = await axios.get(`${BaseUrl}/manage_corporate_order/list_by_customer/${customerId}`); 
                if (response.data && Array.isArray(response.data)) {
                    setOrders(response.data);
                    setTotalEntries(response.data.total);
                } else {
                    setOrders([]);
                }
            } catch (error) {
                console.error('Error fetching orders:', error);
                setOrders([]);
                toast.error('Failed to fetch Order data');
            }
        };

        const fetchPaymentModes = async () => {
            try {
                const response = await axios.get(`${BaseUrl}/paymentmode/getactive`);
                if (response.data && Array.isArray(response.data)) {
                    const map = {};
                    response.data.forEach(pm => {
                        map[pm.sno] = pm.paymentmode_name;
                    });
                    setPaymentModeMap(map);
                } else {
                    setPaymentModeMap({});
                }
            } catch (error) {
                console.error('Failed to fetch payment modes:', error);
                setPaymentModeMap({});
            }
        };

        const fetchitemSchedule = async () => {
            try {
                const response = await axios.get(`${BaseUrl}/item-schedule/items/active`);
                const list = response.data?.data;
                if (Array.isArray(list)) {
                    const formatted = list.map(item => ({
                        value: String(item.sno),
                        label: item.itemschedule_name
                    }));
                    setMealsPeriod(formatted);
                } else {
                    setMealsPeriod([]);
                }
            } catch (error) {
                console.error('Failed to fetch Meals period:', error);
                setMealsPeriod([]);
            }
        };

        const fetchCateringType = async () => {
            try {
                const response = await axios.get(`${BaseUrl}/cateringtype/getactive`);
                if (response.data && Array.isArray(response.data)) {
                    const formatted = response.data.map(item => ({
                        value: String(item.sno),
                        label: item.catering_type
                    }));
                    setCateringType(formatted);
                }
            } catch (error) {
                console.error('Failed to fetch Catering Type:', error);
                setCateringType([]);
            }
        };

        

        const fetchFunctionType = async () => {
            try {
                const response = await axios.get(`${BaseUrl}/functiontype/getactive`);
                if (response.data && Array.isArray(response.data)) {
                    const formatted = response.data.map(item => ({
                        value: String(item.sno),
                        label: item.function_type
                    }));
                    setFunctionType(formatted);
                }
            } catch (error) {
                console.error('Failed to fetch Function Type:', error);
                setFunctionType([]);
            }
        };

        

        // Call all fetches
        fetchCustomer();
        fetchOrder();
        fetchPaymentModes();
        fetchCateringType();
        fetchFunctionType();
        fetchitemSchedule();
        fetchPaymentlist();
    }, []);

    const getMealsPeriodLabel = (sno) => {
        if (!Array.isArray(mealsPeriod)) return '';
        const found = mealsPeriod.find(mp => mp.value === String(sno));
        return found?.label || '';
    };

    const getCateringTypeLabel = (sno) => {
        if (!Array.isArray(cateringType)) return '';
        const found = cateringType.find(ct => ct.value === String(sno));
        return found?.label || '';
    };

    const getFunctionTypeLabel = (sno) => {
        if (!Array.isArray(functionType)) return '';
        const found = functionType.find(ft => ft.value === String(sno));
        return found?.label || '';
    };


    const getOrderStatus = (status) => {
        switch (status) {
            case "1":
                return { label: "Ordered", bgColor: "#ffc107", textColor: "black" }; // yellow
            case "2":
                return { label: "Order Confirmed", bgColor: "#28a745", textColor: "white" }; // green
            case "3":
                return { label: "Order Postponed", bgColor: "#17a2b8", textColor: "white" }; // blue/info
            case "4":
                return { label: "Order Cancelled", bgColor: "#dc3545", textColor: "white" }; // red
            case "5":
                return { label: "Payment Pending", bgColor: "#6f42c1", textColor: "white" }; // purple
            case "6":
                return { label: "Out For Delivery", bgColor: "#007bff", textColor: "white" }; // primary
            case "7":
                return { label: "Delivered", bgColor: "#343a40", textColor: "white" }; // dark
            case "8":
                return { label: "Paid", bgColor: "#28a745", textColor: "white" }; // green
            case "9":
                return { label: "Refund Initiated", bgColor: "#ffb300", textColor: "black" }; 
            case "10":
                return { label: "Refunded", bgColor: "#1976d2", textColor: "white" }; 
            default:
                return { label: "Unknown", bgColor: "#888", textColor: "white" }; // fallback
        }
    };


    return (
        <>
            <div className="d-flex align-items-center justify-content-between page-titles px-0 py-1 mx-0">
                <div className='mb-0'>
                    <div className="mb-0 px-0">
                        <h4 className='breadcrumb-header'>View Corporate Customer</h4>
                    </div>
                    <ol className="breadcrumb fs-7">
                        <li className="breadcrumb-item"><Link to='/dashboard'>Dashboard</Link></li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item">Corporate Management</li>
                        <li className="breadcrumb-item"><i class="fa-solid fa-angles-right fs-8"></i></li>
                        <li className="breadcrumb-item active">Manage Corporate Customer</li>
                    </ol>
                </div>
                <div className="d-flex align-items-center justify-content-center gap-3 bg-gray-300 py-2 px-2 rounded">
                     {customer ? (
                    <div className="d-flex flex-column">
                        <OverlayTrigger trigger="['hover','trigger']" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Basmathi Rice</span></Tooltip>} >
                            <label className='text-danger font-w500 fs-5 text-truncate w-150px'>{customer.customer_name ?? ''}</label>
                        </OverlayTrigger>
                        <OverlayTrigger trigger="['hover','trigger']" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Brand/Quantity</span></Tooltip>} >
                            <label className='text-black font-w400 fs-7'>{customer.customer_number}</label>
                        </OverlayTrigger>
                    </div>
                     ) : ( <div></div> ) }
                </div>
            </div>
             <Col xl={12} className='mb-3'>
                <div className="custom-tab-1">
                    <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
                        <Nav as="ul" className="nav-tabs">
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="basic_info">
                                    <i className="fa-regular fa-user me-2" />
                                    <span className="ms-2 fs-6">
                                        Basic Information
                                    </span>

                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="pay_details">
                                    <i className="fa-regular fa-money-bill-1 me-2" />
                                    <span className="ms-2 fs-6">
                                        Payment Details
                                    </span>
                                    {/* <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                        05
                                    </Badge> */}
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item as="li" >
                                <Nav.Link eventKey="order_details">
                                    <svg viewBox="0 0 1024 1024" class="icon" width="20px" height="20px" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#025d3a"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"><path d="M960.1 258.4H245.8l-36.1-169H63.9v44h110.2l26.7 125 100.3 469.9 530 0.4v-44l-494.4-0.3-22.6-105.9H832l128.1-320.1z m-65 44L855.6 401H276.3l-21.1-98.6h639.9zM304.8 534.5L279.7 417h569.5l-47 117.5H304.8z" fill="#025d3a"></path><path d="M375.6 810.6c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52m0-20c-39.7 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.3-72-72-72zM732 810.6c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52m0-20c-39.7 0-72 32.2-72 72s32.2 72 72 72c39.7 0 72-32.2 72-72s-32.3-72-72-72zM447.5 302.4h16v232.1h-16zM652 302.4h16v232.1h-16z" fill="#025d3a"></path><path d="M276.3 401l3.4 16-3.4-16z" fill="#025d3a"></path></g></svg>
                                    {/* <i className="fa-regular fa-money-bill-1 " /> */}
                                    <span className="ms-2 fs-6">
                                        Order History
                                    </span>
                                    {/* <Badge as="a" href="" bg=" badge-circle" className='badge-outline-danger ms-2 fw-bold fs-8'>
                                        05
                                    </Badge> */}
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>
                        <Tab.Content className="pt-4">
                            <Tab.Pane eventKey="basic_info">
                                {customer ? (
                                    <div className='row border rounded broder-gray mx-2 py-2'>
                                    <div className='col-lg-4 pe-2'>
                                        <div className='px-3 border-end'>
                                        <div className="d-flex justify-content-center w-100 mt-3">
                                            <LightGallery
                                            onInit={onInit}
                                            speed={500}
                                            plugins={[lgThumbnail, lgZoom]}
                                            >
                                            <div data-src={vendor_1} className="d-flex rounded h-175px w-175px p-2">
                                                <img src={customer.image} style={{ width: "100%" }} alt="Profile" className='cursor-pointer' />
                                            </div>
                                            </LightGallery>
                                        </div>
                                        <label className='text-green align-center fs-4 font-w600 mt-3 mb-2'>{customer.customer_name ?? ''}</label>
                                        <div className='fs-6 font-w500 text-black mb-1'>
                                            <OverlayTrigger trigger="['hover','trigger']" placement="bottom" overlay={<Tooltip className='toltip-popover'><span>Email</span></Tooltip>}>
                                            <span className='me-3'><i className='fa-regular fa-envelope fs-5'></i></span>
                                            </OverlayTrigger>
                                            <span>{customer.customer_email ?? '-'}</span>
                                        </div>
                                        <div className='fs-6 font-w500 text-black mb-1'>
                                            <OverlayTrigger trigger="['hover','trigger']" placement="bottom" overlay={<Tooltip className='toltip-popover'><span>Mobile Number</span></Tooltip>}>
                                            <span className='me-3'><i className='fa-solid fa-phone fs-5'></i></span>
                                            </OverlayTrigger>
                                            <span>{customer.customer_number ?? '-'}</span>
                                        </div>
                                        <div className='fs-6 font-w500 text-black mb-1'>
                                            <OverlayTrigger trigger="['hover','trigger']" placement="bottom" overlay={<Tooltip className='toltip-popover'><span>Address</span></Tooltip>}>
                                            <span className='me-3'><i className='fa-solid fa-location-dot fs-5'></i></span>
                                            </OverlayTrigger>
                                            <span>{customer.address ?? '-'}</span>
                                        </div>
                                        </div>
                                    </div>
                                    <div className='col-lg-8 pe-2'>
                                        <div className='px-3'>
                                        <label className='col-12 text-red fs-4 font-w600 mb-3 mt-3'>Company Information</label>
                                        <div className='row'>
                                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <label className='text-gray-800 font-w500 fs-7'>Company Name</label>
                                            <label className='text-black fs-6 font-w500'>{customer.company_name ?? '-'}</label>
                                            </div>
                                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <label className='text-gray-800 font-w500 fs-7'>Company Number</label>
                                            <label className='text-black fs-6 font-w500'>{customer.company_number ?? '-'}</label>
                                            </div>
                                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <label className='text-gray-800 font-w500 fs-7'>GSTIN Number</label>
                                            <label className='text-black fs-6 font-w500'>{customer.gstin_number ?? '-'}</label>
                                            </div>
                                        </div>
                                        <label className='col-12 text-red fs-4 font-w600 mb-3 mt-3'>Bank Information</label>
                                        <div className='row'>
                                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <label className='text-gray-800 font-w500 fs-7'>Bank Name</label>
                                            <label className='text-black fs-6 font-w500'>{customer.bank_name ?? '-'}</label>
                                            </div>
                                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <label className='text-gray-800 font-w500 fs-7'>Branch Name</label>
                                            <label className='text-black fs-6 font-w500'>{customer.branch_name ?? '-'}</label>
                                            </div>
                                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <label className='text-gray-800 font-w500 fs-7'>Account Holder Name</label>
                                            <label className='text-black fs-6 font-w500'>{customer.account_holder_name ?? '-'}</label>
                                            </div>
                                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <label className='text-gray-800 font-w500 fs-7'>Account No</label>
                                            <label className='text-black fs-6 font-w500'>{customer.account_number ?? ''}</label>
                                            </div>
                                            <div className='col-lg-4 col-md-6 col-sm-12 d-flex flex-column mb-3'>
                                            <label className='text-gray-800 font-w500 fs-7'>IFSC Code</label>
                                            <label className='text-black fs-6 font-w500'>{customer.ifsc_code}</label>
                                            </div>
                                        </div>
                                        </div>
                                    </div>
                                    </div>
                                ) : (
                                    <div>Loading customer information...</div>
                                )}
                            </Tab.Pane>

                            <Tab.Pane eventKey="pay_details">
                                <Row>
                                    <Col xl={12}>
                                        <div className="table-container">
                                            
                                            <table className="subscription_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                <thead>
                                                    <tr className="text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                    <th className="min-w-100px text-start">Date</th>
                                                    <th className="min-w-100px">Payment ID</th>
                                                    <th className="min-w-100px text-center">Order ID</th>
                                                    <th className="min-w-100px text-end">Total Amount</th>
                                                    <th className="min-w-100px text-end">Paid Amount</th>
                                                    <th className="min-w-80px text-center">Payment Status</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {!Array.isArray(payments) || payments.length === 0 ? (
                                                    <tr>
                                                        <td colSpan={7} className="text-center">No Payments Found</td>
                                                    </tr>
                                                    ) : (
                                                    payments.map((payment) => {
                                                        const order = payment.corp_orders?.[0];
                                                        const statusInfo = getStatusLabel(payment.status);

                                                        return (
                                                        <tr key={payment.sno}>
                                                            <td className="text-start">
                                                            <label className="text-black font-w400 fs-7">
                                                                {new Date(payment.created_at).toLocaleDateString("en-GB")}
                                                            </label>
                                                            </td>
                                                            <td>
                                                            <label className="text-black font-w400 fs-7">{payment.payment_id}</label>
                                                            </td>
                                                            <td className="text-center">
                                                            <label className="text-black font-w400 fs-7">
                                                                {order?.catering_id || "N/A"}
                                                            </label>
                                                            </td>
                                                            <td align="right">
                                                            <Badge bg="success" className="text-white fs-7 py-0 px-1">
                                                                <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                                <span>{payment.amount.toLocaleString()}</span>
                                                            </Badge>
                                                            </td>
                                                            <td align="right">
                                                            <Badge bg="danger" className="text-white fs-7 py-0 px-1">
                                                                <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                                <span>{payment.paidAmount.toLocaleString()}</span>
                                                            </Badge>
                                                            </td>
                                                            <td className="text-center">
                                                            <label
                                                                className="fs-7 font-w600 py-1 px-2 rounded"
                                                                style={{ backgroundColor: statusInfo.bgColor, color: statusInfo.textColor }}
                                                            >
                                                                {statusInfo.label}
                                                            </label>
                                                            </td>
                                                        </tr>
                                                        );
                                                    })
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>
                            <Tab.Pane eventKey="order_details">
                                <Row>
                                    <Col xl={12}>
                                        <div className="table-container">
                                            <table className="subscription_table table align-middle table-row-dashed table-striped table-hover fs-7 gy-1 gs-2 dataTable">
                                                <thead>
                                                    <tr className=" text-start text-muted fw-bold fs-6 gs-0 th_head">
                                                        <th className='min-w-100px text-start'>Date / Time</th>
                                                        <th className='min-w-100px text-center'>
                                                            Order ID / <OverlayTrigger trigger="['hover','trigger']" placement="bottom" overlay={<Tooltip className='toltip-popover' ><span className='fs-8 text-white fw-semibold'>Payment Closing Date</span></Tooltip>} >
                                                                            <span>PCD </span>
                                                                        </OverlayTrigger>
                                                        </th>
                                                        <th className='min-w-100px text-center'>Function / Catering Type</th>
                                                        <th className='min-w-100px text-center'>Head Count / Meals Period</th>
                                                        <th className='min-w-100px'>Total Amount</th>
                                                        <th className='min-w-100px text-end'>Paid Amount </th>
                                                        <th className='min-w-80px text-center'>Order Status </th>
                                                        <th className='min-w-80px text-end'>Action </th>
                                                    </tr>
                                                </thead>
                                                    <tbody className="text-gray-600 fw-semibold fs-7">
                                                    {Array.isArray(orders) && orders.length > 0 ? (
                                                        orders.map((order, index) => {
                                                        const parsedDate = moment(order.order_date).format('DD-MMM-YYYY');
                                                        const orderTime = moment(order.order_time, 'HH:mm:ss').format('hh:mm A');
                                                        const pcdDate = moment(order.payment_closing_date).format('DD-MMM-YYYY');

                                                        const mealsPeriodLabel = getMealsPeriodLabel(order.meals_period);
                                                        const functionTypeLabel = getFunctionTypeLabel(order.function_type);
                                                        const cateringTypeLabel = getCateringTypeLabel(order.catering_type);

                                                        const total = parseFloat(order.total || 0).toLocaleString();
                                                        const paid = parseFloat(order.paid_amount || 0).toLocaleString();

                                                        const orderStatusLabel = getOrderStatus(String(order.order_status));

                                                        return (
                                                            <tr key={index}>
                                                            <td className="text-start">
                                                                <div className="d-flex flex-column align-items-center">
                                                                <label className="text-black font-w600 fs-7">{parsedDate}</label>
                                                                <label className="text-primary font-w600 fs-7">{orderTime}</label>
                                                                </div>
                                                            </td>
                                                            <td>
                                                                <div className="d-flex flex-column align-items-center">
                                                                <label className="text-black font-w600 fs-7">{order.catering_id}</label>
                                                                <label className="text-danger font-w600 fs-7">{pcdDate}</label>
                                                                </div>
                                                            </td>
                                                            <td className="text-center">
                                                                <div className="d-flex flex-column align-items-center">
                                                                <label className="text-black font-w600 fs-7">{functionTypeLabel}</label>
                                                                <label className="text-dark font-w600 fs-7">{cateringTypeLabel}</label>
                                                                </div>
                                                            </td>
                                                            <td className="text-center">
                                                                <div className="d-flex flex-column align-items-center">
                                                                <label className="text-info border border-info rounded py-1 px-2 font-w600 fs-7">{order.head_count}</label>
                                                                <label className="text-primary font-w600 fs-7">{mealsPeriodLabel}</label>
                                                                </div>
                                                            </td>
                                                            <td align="right">
                                                                <Badge bg="success" className="text-white fs-7 py-0 px-1">
                                                                <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                                <span>{total}</span>
                                                                </Badge>
                                                            </td>
                                                            <td align="right">
                                                                <Badge bg="danger" className="text-white fs-7 py-0 px-1">
                                                                <span><i className="fa-solid fa-indian-rupee-sign me-2"></i></span>
                                                                <span>{paid}</span>
                                                                </Badge>
                                                            </td>
                                                             <td className="text-center">
                                                                <label
                                                                className="fs-7 font-w600 py-1 px-2 rounded"
                                                                style={{
                                                                    backgroundColor: orderStatusLabel.bgColor,
                                                                    color: orderStatusLabel.textColor,
                                                                }}
                                                                >
                                                                {orderStatusLabel.label}
                                                                </label>
                                                            </td>
                                                            <td className="text-end">
                                                                <OverlayTrigger
                                                                    trigger="['hover','trigger']"
                                                                    placement="bottom"
                                                                    overlay={
                                                                    <Tooltip className="tooltip-popover">
                                                                        <span className="fs-8 text-white fw-semibold">View</span>
                                                                    </Tooltip>
                                                                    }
                                                                >
                                                                    <Link
                                                                    to="/corporate-order-view"
                                                                    state={{ order }}
                                                                    className="btn btn-primary tp-btn-light px-2 py-1 me-1 d-inline-flex align-items-center"
                                                                    >
                                                                    <i className="fa-solid fa-eye fs-6 text-primary"></i>
                                                                    </Link>
                                                                </OverlayTrigger>
                                                                </td>
                                                            </tr>
                                                        );
                                                        })
                                                    ) : ( 
                                                        <tr>
                                                        <td colSpan="8" className="text-center text-muted">
                                                            No orders found
                                                        </td>
                                                        </tr>
                                                    )}
                                                    </tbody>
                                            </table>
                                        </div>
                                    </Col>
                                </Row>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>
            </Col >
        </>
    )


}
export default ViewCustomer;